import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: ${props => props.theme.colors.surface};
  border: 1px solid #303050;
  border-radius: 8px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${props => props.theme.colors.accent};
    transform: translateY(-5px);
  }
  
  h3 { 
    margin-top: 0;
    color: ${props => props.theme.colors.accent};
  }
  p { 
    color: ${props => props.theme.colors.textSecondary}; 
    font-size: 0.9rem;
    height: 40px;
    overflow: hidden;
  }
  span { 
    font-size: 0.8rem; 
    opacity: 0.6; 
  }
`;

// Simple component to show rating
const FitnessRating = styled.div`
  margin-top: 1rem;
  font-size: 0.9rem;
  color: ${props => props.theme.colors.textSecondary};
`;

const AgentCard = ({ genome, onClick }) => (
  <Card onClick={onClick}>
    <h3>{genome.manifest.name}</h3>
    <p>{genome.manifest.purpose}</p>
    <FitnessRating>
      Rating: {genome.fitness.avgRating.toFixed(2)} ({genome.fitness.feedbackCount} reviews)
    </FitnessRating>
    <span>v{genome.lineage.version}</span>
  </Card>
);

export default AgentCard;